import { render, staticRenderFns } from "./AttendancesIndex.vue?vue&type=template&id=b4b0ecd6"
import script from "./AttendancesIndex.vue?vue&type=script&lang=js"
export * from "./AttendancesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports